export enum Sale {
    NOTFORSALE = "Niet te koop",
    SOLD = "Verkocht",
    OPTION = "In optie",
}
